<template>

  <div class="col s12">

    <div class="row" v-if="loaded">

      <div class="col s12">
        <div class="card">
          <div class="card-content">
            <span class="card-title">Benvenuto, {{group_name}}</span>
            <p>Questa schermata serve per impostare tutti i dati principali del gruppo e i suoi amministratori.</p>
            <p>Qualsiasi azione effettuata da questo account su <span style="font-style:italic">cani, attività, squadre, tesseramenti, chat</span> risulta bloccata: devi accedere con le credenziali personali che creerai da questa pagina (o che hai già creato)</p>
            <p>Se non ti ricordi il tuo nome utente controlla qui sotto, e se non ricordi la password puoi re-impostarla cliccando sul link "Ho dimenticato la password" presente sotto il riquadro di login.</p>
          </div>
        </div>
      </div>

      <div class="col s12">
        <div class="card">
          <div class="card-content">
            <span class="card-title">Fasi di inserimento dei dati</span>
            <p>Prima di procedere a inserire tutti i soci, segui i seguenti passaggi.</p>
            <ul class="collection" v-if="groupPhase < 7">
              <li
                  class="collection-item"
                  v-if="groupPhase > 1">
                <span class="title">{{groupPhase}} passaggi completati...</span>
                <span class="badge new nonew">
                  <i class="material-icons">done_all</i>
                </span>
              </li>
              <li
                v-for="(phase, i) in groupPhases" :key="i"
                v-if="i > groupPhase"
                class="collection-item avatar"
              >
                <img src="../../assets/icons/touch_app-24px.svg" :alt="'Passaggio '+i" class="circle">
                <span class="title">{{i}}) {{phase.label}}</span>
                <p v-html="phase.hasOwnProperty('description') ? phase.description : 'Descrizione mancante'" />
              </li>
            </ul>
            <p v-else>Hai completato tutti i passaggi obbligatori. Ora puoi procedere all'inserimento delle persone e al loro tesseramento.</p>
          </div>
        </div>
      </div>

      <div class="col s12 m8 offset-m2">
        <GroupData :group="group" :id="group_id" :fields="groupFields" @calculated="onGroupCalculatedPerc"></GroupData>
      </div>

      <div class="col s12 m10 offset-m1"
        v-if="isGroupAdmin">
        <GroupAdministrator
            :key="fake_reloading_key"
            :groupId="group_id"
            :group-data="group"
            :createEnabled="personsEnabled"
            :persons="persons"
            :fields="personFields"
            :admins="admins"
            @refresh="refreshData"></GroupAdministrator>
      </div>

      <div class="col s12 m10 offset-m1">
        <GroupPersons
            :key="fake_reloading_key"
            :groupId="group_id"
            :group-data="group"
            :createEnabled="personsEnabled"
            :persons="persons"
            :fields="personFields"
            :admins="admins"
            @refresh="refreshData"></GroupPersons>
      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';
import Vue from "vue";

export default {
name: "GroupAdmin",

  props: {
    group_id: {
      required: true,
      type: Number
    },
    isGroupAdmin: {
      required: true,
      type: Boolean
    }
  },

  data: () => {
    return {
      group_name: '...',
      group: null,
      groupFields: null,
      groupPhases: null,
      groupPhase: null,
      personsEnabled: false,
      fake_reloading_key: 0,

      loaded: false,

      persons: [],
      personFields: [],
      admins: [],
    }
  },

  methods: {
    onGroupCalculatedPerc: function(perc) {
      if (perc === 100) {
        this.personsEnabled = true;
      } else {
        if (this.personsEnabled) this.personsEnabled = false;

        console.log('Non hai abbastanza dati compilati');
      }
    },

    getGroupData: async function() {
      await axios.get('/index.php?option=com_asdgest&view=dashboard&layout=groupInfo&format=json')
        .then( response => {
          // console.log("Group is:", response.data)
          this.group_name = response.data.group.name;

          this.group = response.data.group;
          this.fake_reloading_key ++;
        })
      .catch(console.log);
    },

    getGroupForm: async function() {
      await axios.get('/index.php?option=com_asdgest&view=dashboard&layout=groupForm&format=json')
        .then( response => {
          console.log("Group form is:", response.data.phase)
          Vue.set(this,'groupFields', response.data.fields);
          Vue.set(this,'groupPhases', response.data.phases);
          Vue.set(this,'groupPhase', response.data.phase);
        })
        .catch( console.log );
    },

    getPersons: async function () {
      await axios.get('/index.php?option=com_asdgest&view=dashboard&layout=personForm&format=json')
          .then( response => {
            // Get person form
            // console.log('Person form is: ', response.data.fields);
            if (Array.isArray(response.data.fields) && response.data.fields.length > 0) {
              Vue.set(this,'personFields',response.data.fields);
            }

            // Get people data
            let pp = [];
            //console.log("Persons are:", response.data.persons);
            for (let personId in response.data.persons) {
              if (!Object.prototype.hasOwnProperty.call(response.data.persons, personId)) continue;

              pp.push(response.data.persons[personId]);
            }

            pp.sort( (a,b) => a.surname.toLowerCase() > b.surname.toLowerCase() );
            Vue.set(this,'persons',pp);

            // Get admins data
            Vue.set(this,'admins',[]);
            const roles = ['owner_id','sec_1_id','sec_2_id'];
            roles.forEach( role => {
              if (!Object.prototype.hasOwnProperty.call(this.group,role)) return;

              if (this.group[role] > 0) {
                const person = this.persons.find((value, i) => value.user_id === this.group[role]);
                if (person) {
                  this.admins.push({
                    id: role,
                    user_id: this.group[role],
                    person_id: person.person_id,
                  })
                } else {
                  this.admins.push({
                    id: role,
                    user_id: 0,
                    person_id: 0,
                  })
                }
              } else if (this.group[role] === 0 || this.group[role] === -42) {
                this.admins.push({
                  id: role,
                  user_id: 0,
                  person_id: 0,
                })
              } else {
                this.admins.push({
                  id: role,
                  user_id: 0,
                  person_id: 0,
                })
              }
            })

          })
          .catch(console.log);

    },

    refreshData: async function() {
      Vue.set(this,'group', {});
      Vue.set(this,'personFields',[]);
      Vue.set(this,'persons',[]);
      Vue.set(this,'groupFields',[]);

      await this.getGroupData();
      await this.getGroupForm();
      await this.getPersons();

      this.loaded = true;
      let loading = document.getElementById('vue_loading');
      if (loading) {
        loading.parentElement.removeChild(loading);
      }
    }
  },

  mounted() {
    this.refreshData();
  }
}
</script>
